import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { downloadFileFromResponse } from '@cbridge-utils/file';
import { IConversionApiDependencySegment } from '@cbridge-packages/api-conversion';
import { catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolPriceAction } from '../symbolPrice.action';

type IDependencies = IConversionApiDependencySegment;

export const exportSymbolPricesEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolPriceAction.exportFile.started),
  mergeMap((params) => {
    return dependencies.csApi.exportPrices().pipe(
      mergeMap((response) => {
        downloadFileFromResponse(response);
        return [];
      }),
      catchApiError((error) => {
        return [SymbolPriceAction.exportFile.failed({ params, error }), createApiErrorNotification(error)];
      }),
    );
  }),
);
